import { Link } from "react-router-dom";
import { BRAND_LOGO_BLUE } from "@/lib/brand";
import BrandLogo from "@/components/common/BrandLogo";

export default function AuthLayout({ children, title, subtitle, right }) {
  return (
    <div className="min-h-screen bg-white flex">
      {/* Left — brand panel */}
      <aside
        className="hidden lg:flex w-[42%] max-w-[600px] relative overflow-hidden text-white flex-col justify-between p-12"
        style={{
          background: `linear-gradient(135deg, ${BRAND_LOGO_BLUE} 0%, #0036A0 55%, ${BRAND_LOGO_BLUE} 100%)`,
        }}
      >
        {/* Decorative blobs */}
        <div
          className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full pointer-events-none"
          style={{
            background:
              "radial-gradient(circle, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 70%)",
          }}
        />
        <div
          className="absolute -bottom-40 -right-20 w-[480px] h-[480px] rounded-full pointer-events-none"
          style={{
            background:
              "radial-gradient(circle, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 70%)",
          }}
        />

        <div className="relative">
          <Link
            to="/"
            data-testid="auth-logo"
            className="inline-block shadow-[0_10px_30px_-12px_rgba(0,0,0,0.4)]"
          >
            <BrandLogo size={48} />
          </Link>
        </div>

        <div className="relative max-w-[420px]">
          <h1 className="text-[34px] font-bold leading-[1.15] tracking-tight">
            {title || "India's most trusted crypto exchange."}
          </h1>
          <p className="mt-6 text-white/80 leading-[1.9] text-[15px]">
            {subtitle ||
              "Bank-grade security. FIU-IND compliant. Trade 250+ assets with INR & USDT."}
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4">
            {[
              { k: "250+", v: "Assets" },
              { k: "FIU-IND", v: "Compliant" },
              { k: "24/7", v: "Support" },
            ].map((s) => (
              <div
                key={s.v}
                className="rounded-[14px] p-4 border border-white/15 bg-white/5 backdrop-blur-sm"
              >
                <div className="text-[18px] font-bold">{s.k}</div>
                <div className="text-[12px] text-white/70 mt-1">{s.v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative text-[12px] text-white/60">
          © {new Date().getFullYear()} CoinMBX. All rights reserved.
        </div>
      </aside>

      {/* Right — form */}
      <main className="flex-1 flex items-center justify-center px-6 py-10 lg:p-16 relative">
        {/* Mobile logo */}
        <Link to="/" className="absolute top-6 left-6 lg:hidden">
          <BrandLogo size="sm" />
        </Link>
        {right ? (
          <div className="absolute top-6 right-6 text-[14px] text-cm-grey">{right}</div>
        ) : null}
        <div className="w-full max-w-[460px]">{children}</div>
      </main>
    </div>
  );
}
